export const useBeforeResize = () => {
  const beforeResize = () => {
    console.log('beforeResize');
  };

  return {
    beforeResize,
  };
};
